import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useToasts } from "react-toast-notifications";
import { useEffect, useState } from "react";
import Select from "react-select";
import "../../styles.css";
import ModalCreatorConfirm from "./modal-confirm";

const customStyles = {
    menuList: (provided, state) => ({
        ...provided,
        textAlign: "left",
    }),
};

const CreatorModal = (props) => {
    const { addToast } = useToasts();
    const {
        users,
        total,
        params,
        tableAction,
        showModal,
        setShowModal,
        getPUs,
        getAllCreators,
        menuIsOpen,
        setMenuOpen,
        setUpdateCreator,
        isBusy=false
    } = props;
    const initialState = {
        pu: null,
        rank: tableAction === "edit-global" ? "" : total + 1,
    };
    const [search, setSearch] = useState("");
    const [isSearching, setSearching] = useState(false);
    const [creatorForm, setCreatorForm] = useState(initialState);
    const [isShowConfirm, setShowConfirm] = useState(false);
    const [isDisableSearchBtn, setDisableSearchBtn] = useState(false);
    const [errors, setErrors] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    useEffect(() => {
        if (showModal) {
            if (params) {
                setCreatorForm({
                    ...creatorForm,
                    id: params.id,
                    pu: {
                        login: params.pu.login,
                        id: params.pu.id,
                    },
                    rank: params.rank,
                });
            } else {
                setCreatorForm(initialState);
            }
            setErrors([])
        }
    }, [params, showModal]);

    const handleSave = async () => {
        const params = {
            id:
                tableAction === "edit-global"
                    ? creatorForm.pu?.creator_id
                    : creatorForm.id || null,
            creator: creatorForm.pu?.creator_id || null,
            pu: creatorForm.pu?.id || null,
            rank: creatorForm.rank,
        };
        setIsLoading(true)
        setErrors([])
        await axios
            .post(
                `/api/administration/creator/${
                    tableAction == "edit-global" ? "edit" : tableAction
                }`,
                params
            )
            .then((response) => {
                const data = response.data;
                setShowModal(false);
                setUpdateCreator(true);
                setCreatorForm(initialState);
                setDisableSearchBtn(true);
                setSearch("");
                addToast(data.message, {
                    appearance: "success",
                    autoDismiss: true,
                });
                setIsLoading(false)
                getAllCreators()
            })
            .catch((error) => {
                console.log(error.response);
                setUpdateCreator(false);

                if (error.response.status === 422) {
                    let tmp = []
                    Object.keys(error.response.data.errors).forEach((key) => {
                        tmp.push(error.response.data.errors[key][0])
                    });
                    setErrors(tmp)
                }

                setIsLoading(false)
            });
    };

    const handleSelect = (key, value) => {
        setCreatorForm({
            ...creatorForm,
            [key]: {
                creator_id: value.creator_id,
                login: value.login,
                id: value.id,
            },
            rank: value.rank || initialState.rank,
        });

        setSearch(value.login);
        setMenuOpen(false);
    };

    const handleDelete = async () => {
        await axios
            .post(`/api/administration/creator/delete`, {
                id: params.id,
            })
            .then((response) => {
                const data = response.data;
                setShowConfirm(false);
                setShowModal(false);
                setUpdateCreator(true);
                addToast(data.message, {
                    appearance: "success",
                    autoDismiss: true,
                });
            })
            .catch((error) => {
                console.log(error.response);
                setShowConfirm(false);
                setUpdateCreator(false);
            });
    };

    const handleSearch = () => {
        setSearching(true);
        if (tableAction === "add") {
            getPUs(search);
        }
        if (tableAction === "edit-global") {
            getAllCreators(search);
        }
        setTimeout(() => {
            setMenuOpen(true);
            setSearching(false);
        }, 250);
    };

    const handleInputChange = (value, action) => {
        if (action.action === "input-change") {
            setDisableSearchBtn(false);
            setSearch(value);

            if (!value) {
                setMenuOpen(false);
                setDisableSearchBtn(true);
            }
        }

        if (action.action === "menu-close") {
            setMenuOpen(false);
        }
    };

    const handleCancel = () => {
        setShowModal(false);
        setMenuOpen(false);
        setCreatorForm(initialState);
        setDisableSearchBtn(true);
        setSearch("");
    };

    const clearSearchText = () => {
        setCreatorForm(initialState);
        setSearch('');
    }

    return (
        <Modal
            size="md"
            className="alert-confirm-modal modal-size-custom suggested-creator-modal"
            centered
            show={showModal}
            onHide={handleCancel}
        >
            <Modal.Header closeButton>
                <Modal.Title className={`text-left`}>
                    {tableAction === "add"
                        ? <span>Add to List</span>
                        : tableAction === 'edit'
                        ? <div className="d-flex flex-row align-items-center" style={{gap: tableAction === 'edit' ? 25 : 0}}>
                            <span>Edit Suggested Creator</span>
                            <span>-</span>
                            <span>{params.pu.login}</span>
                        </div>
                        : <span>Edit Suggested Creator</span>
                    }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    {
                        errors.length > 0 && <div className="text-danger">
                            <ul className="mb-2 pl-0 list-unstyled" style={{listStyle: 'none'}}>
                            {errors.map((error, index) => <li key={index} className="text-left">{error}</li>)}
                            </ul>
                        </div>
                    }
                    {!params && (
                        <div
                            className="d-flex flex-row align-items-center justify-content-between search-pu-container"
                            style={{ paddingRight: 35, gap: 15 }}>
                            <div style={{ maxWidth: "82%", minWidth: "82%" }}>
                                <Select
                                    options={users.length > 0 ? users : []}
                                    styles={customStyles}
                                    menuPosition={"fixed"}
                                    getOptionLabel={(option) => option.login}
                                    getOptionValue={(option) => option.id}
                                    value={""}
                                    onChange={(value) =>
                                        handleSelect("pu", value)
                                    }
                                    onInputChange={handleInputChange}
                                    blurInputOnSelect={false} //set by default, but to be sure
                                    closeMenuOnSelect={false}
                                    inputValue={search}
                                    placeholder="Search PU username"
                                    menuIsOpen={menuIsOpen}
                                    noOptionsMessage={() =>
                                        "Sorry, can't find any any results with that keyword"
                                    }
                                    components={{
                                        DropdownIndicator: () => null,
                                        IndicatorSeparator: () => null,
                                        ClearIndicator: () => null,
                                    }}
                                />
                                {
                                    search && <i className="fal fa-times search-clear-icon" onClick={clearSearchText} />
                                }
                            </div>
                            <Button
                                style={{ marginTop: 0 }}
                                onClick={handleSearch}
                                disabled={isDisableSearchBtn || isBusy}
                                variant="primary">
                                {isSearching || isBusy ? (
                                    <div
                                        className="spinner-border spinner-border-sm"
                                        role="status">
                                        <span className="sr-only">
                                            Loading...
                                        </span>
                                    </div>
                                ) : "Search" }
                            </Button>
                        </div>
                    )}

                    <div className={`${tableAction === "edit" ? "mt-0 justify-content-center my-3" : 'justify-content-left mt-4'} d-flex flex-row align-items-center w-100 mr-3`}>
                        <p className={`text-center h4 gap-5 mr-3`}>
                            Rank
                        </p>
                        <input
                            type="number"
                            className="h4 text-center"
                            min="1"
                            max={tableAction === "add" ? total + 1 : total}
                            value={creatorForm.rank}
                            style={{
                                width: "12%",
                                float: tableAction === "edit" ? "unset" : "left",
                                opacity: 0.8
                            }}
                            onChange={(e) =>
                                setCreatorForm({
                                    ...creatorForm,
                                    rank: e.target.value,
                                })
                            }/>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <ModalCreatorConfirm
                    setShowConfirm={setShowConfirm}
                    handleDelete={handleDelete}
                    isShowConfirm={isShowConfirm}
                />

                <div className={`d-flex flex-row justify-content-between align-items-center ${tableAction === "edit" ? "w-100" : ""}`}>
                    {tableAction === "edit" && (
                        <p
                            type="button"
                            className="text-danger mb-1"
                            onClick={() => setShowConfirm(true)}>
                            <u>Remove</u>
                        </p>
                    )}

                    <div className="alertconfirm-btns">
                        <Button
                            onClick={handleCancel}
                            variant="secondary"
                            className="mr-1">
                            Cancel
                        </Button>
                        <Button onClick={handleSave} variant="primary" disabled={isLoading}>
                            { isLoading ? 'Submitting...' : 'Submit'}
                        </Button>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default CreatorModal;
